[
  {
    "id": 1,
    "question_id": 1,
    "label": "Clinician/Physician",
    "value": "Clinician/Physician"
  },
  {
    "id": 2,
    "question_id": 1,
    "label": "Compliance",
    "value": "Compliance"
  },
  {
    "id": 3,
    "question_id": 1,
    "label": "IT",
    "value": "IT"
  },
  {
    "id": 4,
    "question_id": 1,
    "label": "Management",
    "value": "Management"
  },
  {
    "id": 5,
    "question_id": 1,
    "label": "Microbiologist",
    "value": "Microbiologist"
  },
  {
    "id": 6,
    "question_id": 1,
    "label": "Pharm. D.",
    "value": "Pharm. D."
  },
  {
    "id": 7,
    "question_id": 1,
    "label": "Pharmacist",
    "value": "Pharmacist"
  },
  {
    "id": 8,
    "question_id": 1,
    "label": "Procurement",
    "value": "Procurement"
  },
  {
    "id": 9,
    "question_id": 1,
    "label": "QA/QC",
    "value": "QA/QC"
  },
  {
    "id": 10,
    "question_id": 1,
    "label": "Quality",
    "value": "Quality"
  },
  {
    "id": 11,
    "question_id": 1,
    "label": "Scientist",
    "value": "Scientist"
  },
  {
    "id": 12,
    "question_id": 1,
    "label": "Technician",
    "value": "Technician"
  },
  {
    "id": 13,
    "question_id": 1,
    "label": "Other",
    "value": "Other"
  },
  {
    "id": 14,
    "question_id": 2,
    "characterization_id": 1,
    "weight": 3,
    "label": "Managing workload with existing staff levels",
      "value": "Managing workload with existing staff levels"
    },
  {
    "id": 15,
    "question_id": 2,
    "characterization_id": 2,
    "weight": 3,
    "label": "Establishing/meeting metrics",
      "value": "Establishing/meeting metrics"
    },
  {
    "id": 16,
    "question_id": 2,
    "characterization_id": 3,
    "weight": 2,
    "label": "Integrating a new test system",
      "value": "Integrating a new test system"
    },
  {
    "id": 17,
    "question_id": 2,
    "characterization_id": 4,
    "weight": 3,
    "label": "Updating microbiology processes",
      "value": "Updating microbiology processes"
    },
  {
    "id": 18,
    "question_id": 2,
    "characterization_id": 5,
    "weight": 3,
    "label": "Relocating lab space",
      "value": "Relocating lab space"
    },
  {
    "id": 19,
    "question_id": 2,
    "characterization_id": 5,
    "weight": 3,
    "label": "Consolidation/expansion",
      "value": "Consolidation/expansion"
    },
  {
    "id": 20,
    "question_id": 2,
    "characterization_id": 6,
    "weight": 3,
    "label": "Starting a new lab",
      "value": "Starting a new lab"
    },
  {
    "id": 21,
    "question_id": 2,
    "characterization_id": 3,
    "weight": 2,
    "label": "Managing inventory",
      "value": "Managing inventory"
    },
  {
    "id": 22,
    "question_id": 2,
    "weight": 2,
    "label": "Other",
    "value": "Other"
    },
  {
    "id": 23,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 2,
    "label": "Non-standard practices",
      "value": "Non-standard practices"
    },
  {
    "id": 24,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 2,
    "label": "Batch testing",
      "value": "Batch testing"
    },
  {
    "id": 25,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 2,
    "label": "Bottlenecks/delays",
      "value": "Bottlenecks/delays"
    },
  {
    "id": 26,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 2,
    "label": "Frequent interruptions",
      "value": "Frequent interruptions"
    },
  {
    "id": 27,
    "question_id": 3,
    "characterization_id": 2,
    "weight": 2,
    "label": "Corrected/amended reports",
      "value": "Corrected/amended reports"
    },
  {
    "id": 28,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 2,
    "label": "Duplicate testing/documentation",
      "value": "Duplicate testing/documentation"
    },
  {
    "id": 29,
    "question_id": 3,
    "characterization_id": 1,
    "weight": 2,
    "label": "Staff underutilization",
      "value": "Staff underutilization"
    },
  {
    "id": 30,
    "question_id": 3,
    "characterization_id": 3,
    "weight": 1,
    "label": "Excess/insufficient inventory",
      "value": "Excess/insufficient inventory"
    },
  {
    "id": 31,
    "question_id": 4,
    "characterization_id": 7,
    "weight": 5,
    "label": "5 - Not ready",
      "value": "5 - Not ready"
    },
  {
    "id": 32,
    "question_id": 4,
    "characterization_id": 7,
    "weight": 4,
    "label": "4 - Don't know",
      "value": "4 - Don't know"
    },
  {
    "id": 33,
    "question_id": 4,
    "characterization_id": 7,
    "weight": 3,
    "label": "3 - Somewhat ready",
      "value": "3 - Somewhat ready"
    },
  {
    "id": 34,
    "question_id": 4,
    "characterization_id": 7,
    "weight": 2,
    "label": "2 - Ready",
      "value": "2 - Ready"
    },
  {
    "id": 35,
    "question_id": 4,
    "characterization_id": 7,
    "weight": 1,
    "label": "1 - Already adapting",
      "value": "1 - Already adapting"
    },
  {
    "id": 36,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 5,
    "label": "5 - Yes, very dissatisfied",
      "value": "5 - Yes, very dissatisfied"
    },
  {
    "id": 37,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 4,
    "label": "4 - Yes, dissatisfied",
      "value": "4 - Yes, dissatisfied"
    },
  {
    "id": 38,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 3,
    "label": "3 - Yes, neutral",
      "value": "3 - Yes, neutral"
    },
  {
    "id": 39,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 2,
    "label": "2 - Yes, satisfied",
      "value": "2 - Yes, satisfied"
    },
  {
    "id": 40,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 1,
    "label": "1 - Yes, very satisfied",
      "value": "1 - Yes, very satisfied"
    },
  {
    "id": 41,
    "question_id": 5,
    "characterization_id": 7,
    "weight": 1,
    "label": "No",
      "value": "No"
    },
  {
    "id": 42,
    "question_id": 6,
    "characterization_id": 6,
    "weight": 1,
    "label": "Yes",
      "value": "Yes"
    },
  {
    "id": 43,
    "question_id": 6,
    "weight": 1,
    "label": "No",
    "value": "No"
    },
  {
    "id": 44,
    "question_id": 7,
    "characterization_id": 4,
    "weight": 5,
    "label": "5 - Not confident",
      "value": "5 - Not confident"
    },
  {
    "id": 45,
    "question_id": 7,
    "characterization_id": 4,
    "weight": 4,
    "label": "4 - Slightly confident",
      "value": "4 - Slightly confident"
    },
  {
    "id": 46,
    "question_id": 7,
    "characterization_id": 4,
    "weight": 3,
    "label": "3 - Moderately confident",
      "value": "3 - Moderately confident"
    },
  {
    "id": 47,
    "question_id": 7,
    "characterization_id": 4,
    "weight": 2,
    "label": "2 - Very confident",
      "value": "2 - Very confident"
    },
  {
    "id": 48,
    "question_id": 7,
    "characterization_id": 4,
    "weight": 1,
    "label": "1 - Completely confident",
      "value": "1 - Completely confident"
    },
  {
    "id": 49,
    "question_id": 8,
    "characterization_id": 5,
    "weight": 1,
    "label": "Consolidation/expansion",
      "value": "Consolidation/expansion"
    },
  {
    "id": 50,
    "question_id": 8,
    "characterization_id": 1,
    "weight": 1,
    "label": "Staffing",
      "value": "Staffing"
    },
  {
    "id": 51,
    "question_id": 8,
    "characterization_id": 5,
    "weight": 1,
    "label": "Space constraints",
      "value": "Space constraints"
    },
  {
    "id": 52,
    "question_id": 8,
    "characterization_id": 2,
    "weight": 1,
    "label": "Data analytics",
      "value": "Data analytics"
    },
  {
    "id": 53,
    "question_id": 8,
    "characterization_id": 4,
    "weight": 1,
    "label": "Regulatory compliance",
      "value": "Regulatory compliance"
    },
  {
    "id": 54,
    "question_id": 8,
    "characterization_id": 7,
    "weight": 1,
    "label": "New tests/technologies",
      "value": "New tests/technologies"
    },
  {
    "id": 55,
    "question_id": 8,
    "weight": 1,
    "label": "Other",
    "value": "Other"
    },
  {
    "id": 56,
    "question_id": 9,
    "characterization_id": 8,
    "weight": 1,
    "label": "Reduce length of stay",
      "value": "Reduce length of stay"
    },
  {
    "id": 57,
    "question_id": 9,
    "characterization_id": 9,
    "weight": 1,
    "label": "Improve antimicrobial stewardship",
      "value": "Improve antimicrobial stewardship"
    },
  {
    "id": 58,
    "question_id": 9,
    "characterization_id": 8,
    "weight": 1,
    "label": "Reduce time to therapy",
      "value": "Reduce time to therapy"
    },
  {
    "id": 59,
    "question_id": 9,
    "characterization_id": 8,
    "weight": 1,
    "label": "Reduce hospital-associated infection/sepsis costs",
      "value": "Reduce hospital-associated infection/sepsis costs"
    },
  {
    "id": 60,
    "question_id": 9,
    "weight": 1,
    "label": "Other",
    "value": "Other"
  }
]